import { render, staticRenderFns } from "./DiscoverTabFilteringBar.vue?vue&type=template&id=9b1343c0&"
import script from "./DiscoverTabFilteringBar.vue?vue&type=script&lang=js&"
export * from "./DiscoverTabFilteringBar.vue?vue&type=script&lang=js&"
import style0 from "./DiscoverTabFilteringBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports